import React from 'react';
import { CtaButton } from './CtaButton';
import { media } from '../data/product';
const milestones = [{
  year: 'The problem',
  body: 'A shop owner in Ohio was tired of watching his techs hold a flashlight in their teeth. Every job took longer than it should, and the good work happened in bad light.'
}, {
  year: 'The idea',
  body: 'Put the light where the eyes already are. Not on a strap. Not in a hand. Built into the glasses tradesmen already wear every day.'
}, {
  year: 'The build',
  body: 'Two light sources, three interchangeable lenses, USB-C charging and a frame light enough to forget you have it on. Tested by mechanics, roofers, electricians and drivers before anyone could buy one.'
}, {
  year: 'Today',
  body: 'Over 50,000 X1 are on American jobsites, and every one of them is backed by our replacement coverage. Break it. We replace it. That is the whole promise.'
}];
export function StorySection() {
  return <section id="story" className="border-b border-white/10 bg-ink-900" data-id="element-1367" data-mp="1o7oft1kvyq9d">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-1368" data-mp="1o5lgts1r9msi">
        <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-grit-500" data-id="element-1369" data-mp="1t6972bi5tzlo">Our story</p>
        <div className="mt-4 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14" data-id="element-1370" data-mp="1f6hvsij12xbd">
          <div data-id="element-1371" data-mp="1k4jgf7w3r4oy">
            <h2 className="grit-headline text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-1372" data-mp="1k87aq99dfv4q">
              We build gear for
              <br data-id="element-1373" data-mp="1a86mc8wnaoto" />
              <span className="text-grit-500" data-id="element-1374" data-mp="1a8oti0kuingd">the people who build.</span>
            </h2>
            <p className="mt-5 max-w-xl text-lg text-steel-300" data-id="element-1375" data-mp="whjmgdf5esw0">
              GritVue started in a truck bay, not a boardroom. Same grit. Different jobs. A brighter tomorrow.
            </p>

            <ol className="mt-8 max-w-xl" data-id="element-1376" data-mp="mi2n0dqhpb8h">
              {milestones.map(milestone => <li key={milestone.year} className="border-t border-white/10 py-5" data-id="element-1377" data-mp="rhowcc3767c0">
                  <p className="font-display text-xl font-bold uppercase tracking-wide text-grit-500" data-id="element-1378" data-mp="2t6cqlso0o6y0">
                    {milestone.year}
                  </p>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-steel-300" data-id="element-1379" data-mp="2odrwsr541tuh">{milestone.body}</p>
                </li>)}
            </ol>

            <div className="mt-8" data-id="element-1380" data-mp="2ffzj1rf1eu97">
              <CtaButton className="w-full sm:w-auto" data-id="element-1381" data-mp="2fh12aj67in20">Get the Complete System — $49.95</CtaButton>
              <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-grit-500" data-id="element-1382" data-mp="3c4nuu605tla6">
                3 lenses included · Or build your own from $29.95
              </p>
            </div>
          </div>

          <figure data-id="element-1383" data-mp="336veqzmm69lq">
            <img src={media.tradesSheet} alt="American tradesmen across mechanics, construction, HVAC, plumbing, electrical and trucking wearing the GritVue X1" className="block h-auto w-full border border-white/10" data-id="element-1384" data-mp="2y5o4mtx00ybw" />
            <figcaption className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-steel-500" data-id="element-1385" data-mp="1mslrk8u3yqwh">
              Built for what matters
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}